export const googleSSO = {
  ContinueWithGoogle: "Continue with Google",
  Or: "Or",
} as const;
